import { clsx } from 'clsx'
import { memo, useState, useEffect, useCallback } from 'react'

import { useWindowDimensions } from '@shared/lib/useWindowDimensions'
import { Btn } from '@shared/ui/btn'

import styles from './styles.module.scss'

const FCPageUp = () => {
  const windowDimensions = useWindowDimensions()

  const [show, setShow] = useState(true)

  const goUp = useCallback(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    })
  }, [])

  const onScroll = useCallback(() => {
    if (window.scrollY + window.innerHeight / 5 > window.innerHeight) {
      setShow(true)
    } else {
      setShow(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [windowDimensions.height])

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    onScroll()

    window.addEventListener('scroll', onScroll)
  }, [onScroll])

  useEffect(
    () => () => {
      window.removeEventListener('scroll', onScroll)
    },

    [onScroll]
  )

  return (
    show && (
      <div className={styles['page-up']}>
        <Btn
          onClick={goUp}
          className={clsx(
            'animate__animated animate__fadeIn',
            styles['page-up__btn']
          )}
        >
          <i className="fa-solid fa-arrow-up" />
        </Btn>
      </div>
    )
  )
}

export const PageUp = memo(FCPageUp)
